import { Link } from "@tanstack/react-router"
import LogoFullImg from "@/assets/logo-full.svg"

export const LogoFull = () => {
  return (
    <div className="mt-4 mb-4">
      <Link to={"/"}>
        <img src={LogoFullImg} alt="Egab" />
      </Link>
    </div>
  )
}
